// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form should be used to recalculate metadata for all loans that have automatic metadata enabled. Manual metadata loans are not affected
  </span>
</div>

<button
  type="submit"
  class=" btn btn-danger"
  ng-click="\$ctrl.execute()">
  Execute
</button>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/recalculate-metadata-for-all-loans/recalculate-metadata-for-all-loans.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;